'use client';

import Image from 'next/image';
import Link from 'next/link';

import { staticMediaUrl } from '@/fo/util/image-loader';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './BuyNow.styles';

export interface BuyNowProps {
  isNearFooter?: boolean;
}

export function BuyNow({ isNearFooter = false }: BuyNowProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      {!isNearFooter && (
        <Link
          href="/catalog/institut-esthederm/gammy/intensive/?f=problems=430"
          className={slots.image()}
          onClick={() => {
            reachMetrikaGoal('knopka_kupit_seychas_kruglyash');
          }}
        >
          <Image
            className={slots.imageDefault()}
            src={staticMediaUrl('landing/ie_intensive_nad/buy-now_default.png')}
            alt="Купить сейчас"
            width={168}
            height={168}
          />
          <Image
            className={slots.imageHover()}
            src={staticMediaUrl('landing/ie_intensive_nad/buy-now_hover.png')}
            alt="Купить сейчас"
            width={168}
            height={168}
          />
        </Link>
      )}
    </div>
  );
}
